import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import { ToastContainer } from 'react-toastify';
import TransferDriversList from './TransferDriversList';

const TransferDrivers = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Logística', icon: 'icon-map-pinned' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Transportistas' links={breadcrumbLinks} icon={'icon-ship-wheel'} />
					<TransferDriversList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default TransferDrivers;